/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArchitectsControllerFindOneQueryResponse, ArchitectsControllerFindOnePathParams, ArchitectsControllerFindOneQueryParams, ArchitectsControllerFindOne400, ArchitectsControllerFindOne401, ArchitectsControllerFindOne403, ArchitectsControllerFindOne404 } from "../../models/architectsController/ArchitectsControllerFindOne";

function getArchitectsControllerFindOneUrl(id: ArchitectsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/architects/${id}` as const }  
  return res
}

/**
 * @summary Get an architect by ID
 * {@link /api/v1/architects/:id}
 */
export async function architectsControllerFindOne(id: ArchitectsControllerFindOnePathParams["id"], params?: ArchitectsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ArchitectsControllerFindOneQueryResponse, ResponseErrorConfig<ArchitectsControllerFindOne400 | ArchitectsControllerFindOne401 | ArchitectsControllerFindOne403 | ArchitectsControllerFindOne404>, unknown>({ method : "GET", url : getArchitectsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}